import { api } from "./api";

/**
 * The Google Maps browser key, as the CRM sees it.
 *
 * The key comes back in full rather than masked. That is not an oversight - the
 * Maps JavaScript API publishes it in the script URL of every page that draws a
 * map, so a mask here would hide it from the operator and from nobody else.
 * What keeps it safe is the HTTP-referrer restriction on the Google side; see
 * `apps/api/src/modules/crm-maps/lib/keys.ts`.
 */
export interface MapsSettings {
  browserKey: string;
  configured: boolean;
  /** `env` means a deployment variable is in force and the form cannot win. */
  source: "db" | "env" | "none";
  /** Set, but not shaped like a Google key. A warning, never a refusal. */
  suspicious: boolean;
  /**
   * ⚠ Whether a Places key exists, NOT the key. That one is a real secret: it
   * runs server-side lookups and is never published, so it leaves the server
   * the same way the register's contract password does, which is not at all.
   */
  serverKeySet: boolean;
  serverKeySource: "db" | "env" | "none";
}

export const getMapsSettings = (): Promise<MapsSettings> =>
  api.get<MapsSettings>("/admin/crm/maps/settings");

/**
 * Saves the keys.
 *
 * `browserKey` empty clears it - that field shows what is stored, so an emptied
 * box can only mean "remove this". `serverKey` omitted means "leave it alone",
 * because that field never shows its contents and blank is its only way of
 * saying nothing changed.
 */
export const saveMapsSettings = (body: {
  browserKey: string;
  serverKey?: string;
}): Promise<{ ok: boolean }> => api.put("/admin/crm/maps/settings", body);
